<template>
  <div id="dashboard-business">
    <div class="vx-row">
      <!-- CARD 2: Registered Users -->
          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4" @click="openStory">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="EyeIcon"
                statistic=""
                statisticTitle="Story" />
          </div>
    </div>
  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'

export default {
    data() {
        return {
            
        }
    },
    components: {
        StatisticsCardLine
    },
    methods: {
      openStory: function(){
        this.$router.push("/business/story").catch(() => {})
      }
    }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
